import { RefObject, useCallback, useState } from 'react';

import { useIntersectionObserver } from './useIntersectionObserver';

export const useIsVisible = <TElement extends HTMLElement>(
  ref: RefObject<TElement>,
  options?: IntersectionObserverInit
) => {
  const [isIntersecting, setIntersecting] = useState(false);

  const onIntersect = useCallback<IntersectionObserverCallback>(([entry]) => {
    if (entry) {
      setIntersecting(entry.isIntersecting);
    }
  }, []);

  useIntersectionObserver(ref, onIntersect, options);

  return isIntersecting;
};
